import apolloClient from '../../apolloClient';
import eventGroupQueries from '../queries/eventGroup';
import eventGroupMutations from '../mutations/eventGroup';

const getEventGroupByWorkspaceId = async (variables) =>
  apolloClient.query({
    query: eventGroupQueries.GET_EVENT_GROUP_BY_WORKSPACE_ID,
    fetchPolicy: 'no-cache',
    variables,
  });

const createEventGroup = async (variables) =>
  apolloClient.mutate({
    mutation: eventGroupMutations.CREATE_EVENT_GROUP,
    variables,
  });

const updateEventGroupById = async (variables) =>
  apolloClient.mutate({
    mutation: eventGroupMutations.UPDATE_EVENT_GROUP_BY_ID,
    fetchPolicy: 'no-cache',
    variables,
  });

const deleteEventGroupById = async (variables) =>
  apolloClient.mutate({
    mutation: eventGroupMutations.DELETE_EVENT_GROUP_BY_ID,
    fetchPolicy: 'no-cache',
    variables,
  });

export default {
  getEventGroupByWorkspaceId,
  updateEventGroupById,
  createEventGroup,
  deleteEventGroupById,
};
